import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

interface FooterLink {
  readonly label: string;
  readonly path: string;
}

interface SocialLink {
  readonly label: string;
  readonly href: string;
  readonly icon: string;
}

@Component({
  selector: 'app-site-footer',
  imports: [RouterLink],
  templateUrl: './site-footer.component.html',
  styleUrl: './site-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteFooterComponent {
  readonly year = new Date().getFullYear();

  readonly productLinks: readonly FooterLink[] = [
    { label: 'True Availability Platform', path: '/features/true-availability' },
    { label: 'Booking Pages Feature', path: '/features/smart-booking' },
    { label: 'Event Polling Feature', path: '/features/meeting-polling' },
    { label: 'Product Roadmap', path: '/roadmap' },
    { label: 'Pricing Plans', path: '/pricing' }
  ];

  readonly solutionLinks: readonly FooterLink[] = [
    { label: 'For Independent Consultants', path: '/solutions/independent-consultants' },
    { label: 'For Sales Teams', path: '/solutions/sales-teams' }
  ];

  readonly companyLinks: readonly FooterLink[] = [{ label: 'About Heyea', path: '/about' }];

  readonly legalLinks: readonly FooterLink[] = [
    { label: 'Privacy Policy', path: '/privacy-policy' },
    { label: 'Terms of Service', path: '/terms-of-service' }
  ];

  readonly socialLinks: readonly SocialLink[] = [
    {
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/company/heyea/',
      icon: '/assets/b9ce6f119974543779bbcad7563e234be8edd900.webp'
    },
    {
      label: 'YouTube',
      href: 'https://www.youtube.com/@Heyea-ai',
      icon: '/assets/6d78522dd3ecd58c7a9bf1f59dd5244f5f51ae78.webp'
    },
    {
      label: 'Reddit',
      href: 'https://www.reddit.com/r/heyea/',
      icon: '/assets/921ec5eeae43b46d37a78774edb8ef71f25b7730.webp'
    },
    {
      label: 'X (Twitter)',
      href: 'https://x.com/HeyeaAI',
      icon: '/assets/0aa41878d0ceb77292d9f847b2f4e21d688460c1.webp'
    }
  ];
}
